import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import React, { useState, useEffect } from "react";
import { useTitle } from "@/Utilities/Hooks";
import { Account } from "@/Components/Menu/Account";
import Navigation from "@/Components/Menu/Navigation";
import { Container } from "@/Components/Container";
import { LogIn, Menu } from "react-feather";
import { Inertia } from "@inertiajs/inertia";
import { ROLE_ID } from "@/Enums/roles";
import classNames from "classnames";

export default function AppLayout({ title, children }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "";
    }
    return () => {
      document.documentElement.style.overflow = "";
    };
  }, [isMobileMenuOpen]);

  useTitle(title);

  const { auth, organization, agency } = usePage().props;

  const viewingAsAgency =
    organization?.data &&
    auth.user.data.organization_role_id === ROLE_ID.GLOBAL_REPORTER &&
    !route()?.current()?.startsWith("agency.");

  const viewingAsSuperAdmin =
    organization?.data &&
    auth.user.data.organization_role_id === ROLE_ID.SUPER &&
    !route()?.current()?.startsWith("admin.");

  let logoSrc = "/images/logo-large.png";
  if (agency?.data && agency.data.logo) {
    logoSrc = agency.data.logo;
  } else if (organization?.data && organization.data.logo) {
    logoSrc = organization.data.logo;
  }

  return (
    <div className="modal-hidden md:modal-block flex min-h-screen flex-col bg-background">
      <div
        className={classNames("lg:pl-[240px] 4xl:pl-[300px]", {
          "lg:bg-primary": viewingAsAgency || viewingAsSuperAdmin,
        })}
      >
        <Container
          size={"4xl:max-w-screen-3xl"}
          padding={"px-4 lg:px-16 4xl:pl-32"}
          className={"4xl:mx-0"}
        >
          <div
            className={`flex flex-wrap ${viewingAsAgency || viewingAsSuperAdmin ? "text-white" : "pt-4"}`}
          >
            {viewingAsAgency && (
              <div className="max-lg: z-10 flex items-center gap-4 bg-primary p-4 max-lg:mb-4 max-lg:mt-4 max-lg:w-full">
                <p>
                  Currently viewing{" "}
                  <span className="font-bold">{organization.data.name}</span>
                </p>
                <button
                  className="flex items-end gap-2 text-white underline hover:no-underline"
                  onClick={() =>
                    Inertia.put(
                      route("agency.clients.view", {
                        organization: organization.data.id,
                        back: true,
                      }),
                    )
                  }
                >
                  <LogIn size={24} />
                  Switch back
                </button>
              </div>
            )}
            {viewingAsSuperAdmin && (
              <div className="max-lg: z-10 flex items-center gap-4 bg-primary p-4 max-lg:mb-4 max-lg:mt-4 max-lg:w-full">
                <p>
                  Currently viewing{" "}
                  <span className="font-bold">{organization.data.name}</span>
                </p>
                <button
                  className="flex items-end gap-2 text-white underline hover:no-underline"
                  onClick={() =>
                    Inertia.put(
                      route("admin.organizations.view", {
                        organization: agency?.data
                          ? agency.data.id
                          : organization.data.id,
                        back: true,
                      }),
                    )
                  }
                >
                  <LogIn size={24} />
                  {agency?.data ? "Back to agency" : "Back to admin"}
                </button>
              </div>
            )}

            <InertiaLink
              className="flex items-center text-4xl font-bold lg:hidden"
              href={route("welcome")}
            >
              <img
                className="h-10 max-w-[100px] lg:max-h-[60px]"
                src={logoSrc}
                alt={agency?.data?.name || "Gidås"}
              />
            </InertiaLink>

            <Account
              user={auth?.user?.data}
              asAgency={viewingAsAgency || viewingAsSuperAdmin}
            />

            <Menu
              size={40}
              className={`ml-auto cursor-pointer text-typo lg:hidden`}
              onClick={toggleMobileMenu}
            />
          </div>
        </Container>
      </div>

      <Navigation
        auth={auth}
        isMobileMenuOpen={isMobileMenuOpen}
        closeMobileMenu={closeMobileMenu}
      />

      <div className="lg:pl-[240px] 4xl:pl-[300px]">{children}</div>
    </div>
  );
}
